import { createAsyncThunk } from "@reduxjs/toolkit";
import moment from "moment-timezone";
import { isEmpty } from "lodash";

export const checkSession = createAsyncThunk(
  "user/checkSession",
  async (input, thunkAPI) => {
    const { getState, extra: apiService } = thunkAPI;

    const token =
      input || getState().user?.token || localStorage.getItem("token");

    if (!token) {
      return { success: false };
    } else {
      const data = await apiService.user
        .checkSession(token)
        .then((data) => {
          if (data.error) {
            // no session found
            return data;
          } else if (data.success && data.user) {
            const { user = {}, organization = {} } = data;
            const timeZone =
              user.userTimeZone &&
                !isEmpty(user.userTimeZone)
                ? user.userTimeZone
                : moment.tz.guess();

            const userPropertiesMap = user.propertiesMap
              ? {
                propertiesMap: {
                  ...user.propertiesMap,
                },
              }
              : {
                propertiesMap: {
                },
              };

            const usersConsoleRoles =
              user?.userRoles?.find((role) => role.name === "console")?.roles ||
              [];

            //go through the usersConsoleRoles and get all the availableActions for all the roles and set them in an array called availableActions
            //for each role, look into user.rolesMap and get the availableActions based on the role. Put them into an array
            const userAvailableViews = usersConsoleRoles.reduce((acc, role) => {
              return [
                ...acc,
                ...Object.keys(organization.rolesMap?.console?.[role.name].availableViews), //using actions for now. Will convert to availabeleViews after testing this part
              ];
            }, []);

            const userAvailableActions = usersConsoleRoles.reduce((acc, role) => {
              return [
                ...acc,
                ...Object.keys(organization.rolesMap?.console?.[role.name].availableActions),
              ];
            }, []);

            const usersConsoleRole = usersConsoleRoles.find(
              (role) => role.name === "console"
            );

            return {
              appUserId: user.appUserId,
              checkSession: {
                status: "success",
                sessionValid: true,
              },
              email: user.email || "",
              firstName: user.firstName || "",
              lastName: user.lastName || "",
              organizationId: user.organizationId,
              success: true,
              userTimeZone: timeZone,
              token: token,
              userAvailableActions,
              userAvailableViews,
              userPermissions: user.permissions || [],
              userPropertiesMap,
              usersConsoleRole,
              usersConsoleRoles,
            };
          } else {
            return {
              error: "Something went wrong while fetching your user session.",
            };
          }
        })
        .catch((err) => {
          console.log(err);
          return { error: err };
        });

      // data.reduxRequestId = thunkAPI.requestId;
      return data;
    }
  }
);

export const onLogin = createAsyncThunk(
  "user/onLogin",
  async (action, thunkAPI) => {
    const state = thunkAPI.getState().user;

    let { user = {}, token = "", organization = {} } = action;
    const { userTimeZoneUseDefault = true } = user;

    const timeZone =
      user.userTimeZone && !isEmpty(user.userTimeZone)
        ? user.userTimeZone
        : moment.tz.guess();

    const userPropertiesMap = user.propertiesMap
      ? {
        propertiesMap: {
          ...user.propertiesMap,
        },
      }
      : {
        propertiesMap: {
        },
      };

    const usersConsoleRoles =
      user?.userRoles?.find((role) => role.name === "console")?.roles || [];

    const userAvailableViews = usersConsoleRoles.reduce((acc, role) => {
      return [
        ...acc,
        ...Object.keys(organization.rolesMap?.console?.[role.name].availableViews),
      ];
    }, []);
    //perhaps refactor the above but use for loop instead of reduce

    const userAvailableActions = usersConsoleRoles.reduce((acc, role) => {
      return [
        ...acc,
        ...Object.keys(organization.rolesMap?.console?.[role.name].availableActions),
      ];
    }, []);

    const usersConsoleRole = usersConsoleRoles.find(
      (role) => role.name === "console"
    ) || [];

    const data = {
      ...state,
      appUserId: user.appUserId,
      checkSession: {
        sessionValid: true,
        status: "idle",
      },
      email: user.email || "",
      firstName: user.firstName || "",
      lastName: user.lastName || "",
      organizationId: user.organizationId,
      success: true,
      token: token,
      userPermissions: user.permissions || [],
      userPropertiesMap,
      userAvailableActions,
      userAvailableViews,
      usersConsoleRole,
      usersConsoleRoles,
      userTimeZone: timeZone,
      userTimeZoneUseDefault,
    };

    // data.reduxRequestId = thunkAPI.requestId;

    return data;
  }
);

export const updateWidgetSettingsThunk = createAsyncThunk(
  "user/updateWidgetSettingsThunk",
  async (input, thunkAPI) => {
    const { getState, extra: apiService, dispatch } = thunkAPI;

    const { widget, settings } = input;

    const state = getState().user;

    const {
      token = localStorage.getItem("token") || "",
      appUserId = "",
      userPropertiesMap = {},
    } = state;

    const results = await apiService.user
      .updateWidgetSettings({ widget, settings, token, appUserId })
      .then((res) => {
        if (res.error) {
          return dispatch({
            type: "alert/showAlert",
            payload: { type: "error", text: res.error.toString() },
          });
        } else {
          return {
            userPropertiesMap: {
              propertiesMap: {
                ...userPropertiesMap.propertiesMap,
                widgetSettings: {
                  ...(userPropertiesMap.propertiesMap.widgetSettings || {}),
                  [widget]: {
                    ...((userPropertiesMap.propertiesMap.widgetSettings &&
                      userPropertiesMap.propertiesMap.widgetSettings[widget]) ||
                      {}),
                    ...settings,
                  },
                },
              },
            },
          };
        }
      })
      .catch((err) => {
        console.log(err);
        return dispatch({
          type: "alert/showAlert",
          payload: { type: "error", text: err.toString() },
        });
      });

    return results;
  }
);
